/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface IUpdateAddress {
        activate: () => void;
        ncCounties: Array<IAddressListItem>;
        permAddress: ValidationAddress;
        mailAddress: ValidationAddress;
        saving: boolean;
        mailingSameAsPerm: boolean;
        addressError: boolean;
        melissaDataResponse: any;
        countries: Array<IAddressListItem>;
        states: Array<IAddressListItem>;
        phoneNumbers: Array<string>;
        isLimitedProfile: boolean;
    }

    class Address implements IAddress {
        addressType: string;
        firstName: string;
        lastName: string;
        street: string;
        street2: string;
        city: string;
        state: string;
        postalCode: string;
        country: string
        county: string;
        isVerified: boolean;
        resultCodes: string;
        userOverride: boolean;
        signature: string;
        key: string;
    }

    class VerifyAddressResults implements IVerifyAddressResultsViewModel {
        firstName: string;
        lastName: string;
        action: string;
        providedAddressHasErrors: boolean;
        key: string;
        providedAddress: Address;
        suggestedAddress: Address;

    }

    class UpdateAddress implements IUpdateAddress {
        static controllerId: string = "updateAddress";
        static $inject: string[] = ["addressService", "Restangular", "common", "$timeout", "config", "loginCredentials"];
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        ncCounties: Array<IAddressListItem>;
        permAddress: ValidationAddress;
        mailAddress: ValidationAddress;
        saving: boolean;
        mailingSameAsPerm: boolean;
        addressError: boolean;
        melissaDataResponse: any;
        addressVerified: boolean;
        countries: Array<IAddressListItem>;
        states: Array<IAddressListItem>;
        newEmail: string;
        user: IUserProfile;
        phoneNumbers: Array<any>;
        isLimitedProfile: boolean;
        newPassword: string;
        confirmNewPassword: string;

        constructor(private addressService: IAddressService,
            private Restangular: Restangular.IService,
            private common: ICommonFactory,
            private $timeout: angular.ITimeoutService,
            private config: IConfig,
            private loginCredentials: ILoginCredentials) {
            this.log = common.logger.getLogFn(UpdateAddress.controllerId);
            this.logError = common.logger.getLogFn(UpdateAddress.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(UpdateAddress.controllerId, "success");
            this.phoneNumbers = [];
            this.activate();
        }

        activate() {
            var promises: angular.IPromise<void>[] = [];

            if (this.loginCredentials.updatePhone || this.loginCredentials.updatePassword) {
                this.isLimitedProfile = true;
                promises.push(this.getLimitedProfile());
            }
            else {
                this.isLimitedProfile = false;
                promises.push(this.getProfile());
            }


            this.common.activateController(promises, UpdateAddress.controllerId)
                .then(() => {
                    this.log("Activated UpdateAddress View");
                    this.newEmail = '';
                });

        }

        getLimitedProfile = () => {
            return this.Restangular.one("users/limitedProfile").get(this.loginCredentials.loginInfo)
                .then((result) => {
                    this.user = result;
                    if (result.phoneNumber) {
                        this.phoneNumbers.push({ type: "Permanent Phone", value: result.phoneNumber });
                    }

                    if (result.daytimePhone) {
                        this.phoneNumbers.push({ type: "Daytime Phone", value: result.daytimePhone });
                    }

                    if (result.eveningPhone) {
                        this.phoneNumbers.push({ type: "Evening Phone", value: result.eveningPhone });
                    }

                    if (result.mailingPhone) {
                        this.phoneNumbers.push({ type: "Mailing Phone", value: result.mailingPhone });
                    }
                }, (reason) => {
                    this.logError("An error occurred. Please try again later.", reason, true);
                });
        }

        getProfile = () => {
            return this.Restangular.one("users/profile").get()
                .then((result) => {
                    if (result) {
                        this.user = result;
                        this.user.permAddress = this.user.permAddress || new Address();
                        this.user.mailAddress = this.user.mailAddress || new Address();
                        this.user.permAddress.firstName = result.firstName;
                        this.user.permAddress.lastName = result.lastName;
                        this.user.mailAddress.firstName = result.firstName;
                        this.user.mailAddress.lastName = result.lastName;
                        this.user.permAddress.userOverride = false;
                        this.user.mailAddress.userOverride = false;

                        //this.user.addressInvalid = this.config.updateAddressAtLogin || false;
                        //this.user.emailInvalid = this.config.cfncEmailError || false;
                        //this.user.phoneNumberInvalid = this.config.phoneNumberInvalid || false;

                        
                    }
                }, (reason) => {
                    this.logError(reason, reason, true);
                });
        };

        saveProfile() {
            this.saving = true;
            this.user.permAddress.key = "permanent";
            this.user.mailAddress.key = "mailing";
            if (this.user.passwordInvalid)
                this.loginCredentials.loginInfo.newPassword = this.newPassword;

            if ((!this.config.cfncAddressError && !this.user.addressInvalid) || this.addressVerified || ["US", "CA"].indexOf(this.user.permAddress.country) == -1 && ["US", "CA"].indexOf(this.user.mailAddress.country) == -1) {
                if (!this.config.cfncAddressError && !this.user.addressInvalid) {
                    this.user.permAddress = null;
                    this.user.mailAddress = null;
                }
                if (this.newEmail != '')
                    this.user.email = this.newEmail;

                if (this.isLimitedProfile) {
                    this.Restangular.one("users/limitedProfile/save").post(null, this.user, this.loginCredentials.loginInfo)
                        .then((result) => {
                            if (this.user.passwordInvalid)
                                this.loginCredentials.loginInfo.password = this.newPassword;
                            //this.common.authentication.login(this.loginCredentials.loginInfo);
                        }, (reason) => {
                            this.saving = false;
                            this.logError(reason, reason, true);
                        });
                        
                } else {
                    this.Restangular.all("users/profile/save").customPUT(this.user)
                        .then((response) => {
                            this.common.authentication.redirect();
                        }, (reason) => {
                            this.saving = false;
                            this.logError(reason, reason, true);
                        });
                }

            }
            else {
                var permAddress = new Address();
                permAddress.firstName = this.user.firstName;
                permAddress.lastName = this.user.lastName;
                permAddress.street = this.user.permAddress.street;
                permAddress.street2 = null;
                permAddress.city = this.user.permAddress.city;
                permAddress.state = this.user.permAddress.state;
                permAddress.postalCode = this.user.permAddress.postalCode;
                permAddress.country = this.user.permAddress.country;
                permAddress.county = this.user.permAddress.county;
                permAddress.key = "permanent";


                var mailingAddress = new Address();
                mailingAddress.firstName = this.user.firstName
                mailingAddress.lastName = this.user.lastName;
                mailingAddress.street = this.user.mailAddress.street;
                mailingAddress.street2 = null;
                mailingAddress.city = this.user.mailAddress.city;
                mailingAddress.state = this.user.mailAddress.state;
                mailingAddress.postalCode = this.user.mailAddress.postalCode;
                mailingAddress.country = this.user.mailAddress.country;
                mailingAddress.county = this.user.mailAddress.county;
                mailingAddress.key = "mailing";


                this.addressService.validate([permAddress, mailingAddress])
                    .then((result) => {
                        result.forEach((selection) => {
                            if (selection.key == "permanent") {
                                this.user.permAddress.city = selection.city;
                                this.user.permAddress.postalCode = selection.postalCode;
                                this.user.permAddress.state = selection.state;
                                this.user.permAddress.street = selection.street;
                                this.user.permAddress.street2 = selection.street2;
                                this.user.permAddress.isVerified = selection.isVerified;
                                this.user.permAddress.userOverride = selection.userOverride;
                                this.user.permAddress.resultCodes = selection.resultCodes;
                                this.user.permAddress.signature = selection.signature;
                                this.user.permAddress.addressType = selection.addressType;
                                this.user.permAddress.country = selection.country;
                                this.user.permAddress.county = selection.county;
                            }

                            if (selection.key == "mailing") {
                                this.user.mailAddress.city = selection.city;
                                this.user.mailAddress.postalCode = selection.postalCode;
                                this.user.mailAddress.state = selection.state;
                                this.user.mailAddress.street = selection.street;
                                this.user.mailAddress.street2 = selection.street2;
                                this.user.mailAddress.isVerified = selection.isVerified;
                                this.user.mailAddress.userOverride = selection.userOverride;
                                this.user.mailAddress.resultCodes = selection.resultCodes;
                                this.user.mailAddress.signature = selection.signature;
                                this.user.mailAddress.addressType = selection.addressType;
                                this.user.mailAddress.country = selection.country;
                                this.user.mailAddress.county = selection.county;
                            }
                        });

                        this.addressVerified = true;
                        this.saveProfile();

                    }, (reason) => {
                        reason.addresses.forEach((selection) => {
                            if (selection.key == "permanent") {
                                this.user.permAddress.city = selection.city;
                                this.user.permAddress.postalCode = selection.postalCode;
                                this.user.permAddress.state = selection.state;
                                this.user.permAddress.street = selection.street;
                                this.user.permAddress.street2 = selection.street2;
                                this.user.permAddress.signature = selection.signature;
                                this.user.permAddress.addressType = selection.addressType;
                            }

                            if (selection.key == "mailing") {
                                this.user.mailAddress.city = selection.city;
                                this.user.mailAddress.postalCode = selection.postalCode;
                                this.user.mailAddress.state = selection.state;
                                this.user.mailAddress.street = selection.street;
                                this.user.mailAddress.street2 = selection.street2;
                                this.user.mailAddress.signature = selection.signature;
                                this.user.mailAddress.addressType = selection.addressType;
                            }
                        });
                        this.saving = false;
                    });
            }
        }


        verifyAddress = (address: Address): ng.IPromise<any> => {
            var defer = this.common.$q.defer();
            if (address.country === "US" || address.country === "CA") {
                defer.promise = this.Restangular.all("Address").all("Validate").post(address)
            }
            else {
                defer.resolve(null);
            }

            return defer.promise;
        };
    }

    angular.module("app").controller(UpdateAddress.controllerId, UpdateAddress);
}